import React, { useEffect } from "react";

// Hooks
import { createContext, useContext, useState } from "react";

// Services
import { IonContent } from "@ionic/react";
import { debug } from "../App";
import { BasicTemplate } from "../components/PageTemplates";
import { ApiService } from "../services";

export const ApplicationContext = createContext<any>(null);

export function useApplication() {
  return useContext(ApplicationContext);
}

const ShowError = (props: any) => (
  <BasicTemplate hideHeader={true} hideBackButton={true}>
    <IonContent fullscreen={true} className={"ion-padding"}>
      <p>{props.error}</p>
      <pre>{props.url}</pre>
    </IonContent>
  </BasicTemplate>
);

export function ApplicationProvider({ children }: { children: any }) {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [application, setApplication] = useState<any>({});
  const [url, setUrl] = useState<string>("");

  const refreshManifest = () => {
    debug("Loading application manifest");
    setLoading(true);

    ApiService.get("manifest")
      .then((response: any) => {
        debug("Got application manifest", response);
        setApplication(response);
        setError(null);
        setLoading(false);
      })
      .catch((error: any) => {
        debug("Error getting application manifest", error);
        setError("An error occurred communicating with the server. Please try again later");
        setLoading(false);
      });
  };

  useEffect(() => {
    setUrl(ApiService.baseUrl);
    refreshManifest();
  }, []);

  return (
    <ApplicationContext.Provider
      value={{
        application,
      }}
    >
      {!loading && (error ? <ShowError error={error} url={url} /> : children)}
    </ApplicationContext.Provider>
  );
}
